/**
 * There will be one reducer file per page / common component
 */
import {
    GET_APPLIED_FILTERS,
    GET_APPLIED_FILTERS_SUCCESS,
    GET_APPLIED_FILTERS_FAILURE,
    SET_ORDER_CONDTION,
    RESET_FILTER_DATA_AFTER_IMPERSONATION,
} from '../actions';

const initialState = {
    basicFilters: [],
    salesHierarchies: [],
    accountsSelected: [],
    orderStatusesSelected: [],
    orderTypesSelected: [],
    physiciansSelected: [],
    proceduresSelected: [],
    statusCode: 0,
    statusMessage: '',
    displayFilters: [],
    defaultCalendarView: {},
    defaultCalendarViewId: '',
    displayOrderCondition: true,
    loading: false,
};

const getDisplayFilters = (
    accountsSelected,
    orderTypesSelected,
    orderStatusesSelected,
    physiciansSelected,
    proceduresSelected,
    orderConditionSelected
) => {    
    let tempDisplayFilters = [];
    if (accountsSelected && accountsSelected.length)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            ...accountsSelected.map((account) => account.accountName),
        ];
    if (orderTypesSelected && orderTypesSelected.length)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            ...orderTypesSelected?.map((status) => status.orderTypeName),
        ];
    if (orderStatusesSelected && orderStatusesSelected.length)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            ...orderStatusesSelected?.map((status) => status.statusDescription),
        ];
    if (physiciansSelected && physiciansSelected.length)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            ...physiciansSelected?.map((physician) => physician.name),
        ];
    if (proceduresSelected && proceduresSelected.length)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            ...proceduresSelected?.map((procedure) => procedure.procedureName),
        ];
    if (!orderConditionSelected)
        tempDisplayFilters = [
            ...tempDisplayFilters,
            orderConditionSelected ? 'Assigned' : 'Unassigned',
        ];
    return tempDisplayFilters;
};

const AppliedFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_APPLIED_FILTERS:
            return {
                ...state,
                loading: true,
            };
        case GET_APPLIED_FILTERS_SUCCESS: {
            let basicFilters = action.data.basicFilters || [];
            const salesHierarchies = action.data.salesHierarchies || [];
            const allBasicFiltersUnselected = basicFilters.every((filter) => !filter.selected);
            const allSalesHierarchiesUnselected = salesHierarchies.every((filter) => !filter.selected);
            if (
                basicFilters.length > 0 &&
                allBasicFiltersUnselected &&
                allSalesHierarchiesUnselected
            ) {
                basicFilters = basicFilters.map((filter) =>
                    filter.name === 'All'
                        ? { ...filter, selected: true }
                        : filter
                );
            }
            const accountsSelected = action?.data?.accountsSelected || [];
            const orderTypesSelected = action.data.orderTypesSelected || [];
            const orderStatusesSelected =
                action.data.orderStatusesSelected || [];
            const physiciansSelected = action.data.physiciansSelected || [];
            const proceduresSelected = action.data.proceduresSelected || [];
            const orderConditionSelected = action.data.assignedFlag.assigned;
            const statusCode = action.data.statusCode;
            const statusMessage = action.data.statusMessage;

            return {
                ...state,
                basicFilters: basicFilters,
                salesHierarchies: salesHierarchies || [],
                accountsSelected: accountsSelected || [],
                orderTypesSelected: orderTypesSelected || [],
                orderStatusesSelected: orderStatusesSelected || [],
                physiciansSelected: physiciansSelected || [],
                proceduresSelected: proceduresSelected || [],
                displayFilters: getDisplayFilters(
                    accountsSelected,
                    orderTypesSelected,
                    orderStatusesSelected,
                    physiciansSelected,
                    proceduresSelected,
                    orderConditionSelected
                ),
                defaultCalendarView:
                    [...basicFilters, ...salesHierarchies]?.find((filter) => {
                        return filter.selected;
                    }) || {},
                defaultCalendarViewId: [
                    ...basicFilters,
                    ...salesHierarchies,
                ]?.find((filter) => {
                    return filter.selected;
                })?.id,
                displayOrderCondition: orderConditionSelected,
                statusCode: statusCode,
                statusMessage: statusMessage,
                loading: false,
            };
        }
        case GET_APPLIED_FILTERS_FAILURE:
            return {
                ...state,
                basicFilters: [],
                salesHierarchies: [],
                accountsSelected: [],
                orderTypesSelected: [],
                orderStatusesSelected: [],
                physiciansSelected: [],
                proceduresSelect: [],
                displayFilters: [],
                statusCode: 0,
                statusMessage: '',
                displayOrderCondition: true,
                loading: false,
            };
        case SET_ORDER_CONDTION:
            return {
                ...state,
                displayOrderCondition: action.payload,
            };
        case RESET_FILTER_DATA_AFTER_IMPERSONATION:
            return {
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default AppliedFiltersReducer;
